import hydroscripts from '../../assets/js/site.scripts.js'

export default {

  data() {
    return {

      firstName: '',
      lastName: '',
      data: []

    }

  },

  mounted() {
    this.$router.app.$on('reloadAuth', (data) => {
      this.firstName = authDetails.FirstName
      this.lastName = authDetails.LastName

    })

    this.firstName = authDetails.FirstName
    this.lastName = authDetails.LastName;
    this.data = {

      firstName: this.firstName,
      lastName: this.lastName,
      email: authDetails.email,
      isEdit: false


    }
    if (authDetails.IsFirstLogin == "True") {
      this.loadPostsignupModel()
    }


    this.$router.app.$emit('invocksidebar', true)
    $.event.trigger({
      type: 'newMessage'

    })

  },
  methods: {
    loadPostsignupModel() {




      $('#PostsignupModel').modal('show')
    }

  }

}



// WEBPACK FOOTER //
// ./src/pages/AdminDashboard/AdminDashboard.controller.js